import {ChangeDetectorRef, Component, ContentChild, ElementRef, EventEmitter, Input, OnInit, Output, TemplateRef} from '@angular/core';

@Component({
  selector: 'app-exg-sort-header-table',
  templateUrl: './exg-sort-header-table.component.html'
})
export class ExgSortHeaderTableComponent implements OnInit {
  @Input() containerClass = 'grid cols-12';
  @Input() allowMultiSelection = false;
  @Input() allowSingleSelection = false;
  @Input() selectSource: Array<any> = [];
  @Input() selectKey: string | null = null;
  @Input() displayStateMessage = 'Es wurden keine Daten gefunden!';
  @Input() displayState = 0;
  @Input() uiSort: any = {};
  @Input() metaInfo: any = {};

  @ContentChild('headerTemplate') headerTemplate!: TemplateRef<ElementRef>;
  @ContentChild('rowTemplate') rowTemplate!: TemplateRef<ElementRef>;

  @Output() RowChange: EventEmitter<number> = new EventEmitter<number>();
  @Output() ItemSelect: EventEmitter<number> = new EventEmitter<number>();
  @Output() RowDblClick: EventEmitter<number> = new EventEmitter<number>();
  @Output() SortClicked: EventEmitter<number> = new EventEmitter<number>();

  private _rowSource: Array<any> = [];
  _selectState = false;

  get rowSource(): Array<any> {
    return this._rowSource;
  }

  @Input() set rowSource(value: Array<any>) {
    this._rowSource = value;
    this._selectState = false;
  }

  clickrule = {prevent: false, timer: 0};

  // Current Selected Index of Data
  private _selectedRow = -1;
  get selectedRow(): number {
    return this._selectedRow;
  }

  set selectedRow(value: number) {
    this.clickrule.prevent = false;
    this.clickrule.timer = setTimeout(() => {
      if (!this.clickrule.prevent) {
        this._selectedRow = value;
        this.RowChange.emit(value);
      }
    }, 250);
  }

  onDblClick(value: number): void {
    this.clickrule.prevent = true;
    clearTimeout(this.clickrule.timer);
    this.RowDblClick.emit(value);
  }

  constructor(
    private cdr: ChangeDetectorRef
  ) {
    setInterval(() => {
      this.cdr.markForCheck();
    }, 50);
  }

  ngOnInit(): void { }

  select(index: any, value: any): void {
    const key = this.rowSource[index][(this.selectKey as string)];
    this.doSelect(key, value);
  }

  selectClick(e: Event, index: any): void {
    e.preventDefault();
    e.stopPropagation();
    this.select(index, !this.isSelected(index));
  }

  doSelect(key: any, value: any): void {
    const pos = this.selectSource.indexOf(key);
    if (value === true) {
      if (pos === -1) {
        this.selectSource.push(key);
      }
    }
    if (value === false) {
      if (pos > -1) {
        this.selectSource.splice(pos, 1);
      }
    }
    this.ItemSelect.emit(this.selectSource.length);
  }

  isSelected(index: any): boolean {
    return (this.selectSource.indexOf(this.rowSource[index][(this.selectKey as string)]) > -1);
  }

  selectAll(value: boolean): void {
    this._selectState = value;
    this.rowSource.forEach((element) => {
      this.doSelect(element[(this.selectKey as string)], value);
    });
  }

  resetAllSortingToZeroExceptPressedFilter(pressedIndex: number): void {
    this.uiSort.forEach((header: any) => {
      if (this.uiSort[pressedIndex] !== header){
        header.uiValue = 0;
      }
    });
  }

  toggleSearchValue(pressedIndex: number): void {
    this.resetAllSortingToZeroExceptPressedFilter(pressedIndex);
    this.uiSort[pressedIndex].uiValue = (this.uiSort[pressedIndex].uiValue + 1) % 3;
    if (this.uiSort[pressedIndex].uiValue === 0){
      this.uiSort[pressedIndex].uiValue = 1;
    }
    this.applySort();
  }

  resetSortingtoDefault(): void {
    this.uiSort.forEach(
      (obj: any) => { obj.uiValue = obj.sortDefault; }
    );
    this.applySort();
  }

  applySort(): void {
    this.ComputeSortValue(this.metaInfo, this.uiSort);
    this.SortClicked.emit(this.metaInfo);
  }

  ComputeSortValue(targetobj: any, source: any[]): void {
    const sval = ['', 'asc', 'desc'];
    targetobj.dataSort = {};
    source.forEach((obj) => {
      if (obj.uiValue > 0) {
        if (obj.sortField.includes(',')) {
          const sortFields = obj.sortField.split(',');
          for (const sortField of sortFields) {
            targetobj.dataSort[sortField] = sval[obj.uiValue];
          }
        } else {
          targetobj.dataSort[obj.sortField] = sval[obj.uiValue];
        }
      }
    });
  }
}
